<template lang="pug">
  v-dialog.grey(v-model="dialog" scrollable dark max-width="1100")
    template(v-slot:activator="{ on }")
      v-btn(color="primary" v-on="on" text)
        v-icon mdi-text-box-outline
    v-card
      v-card-title.d-flex.flex-nowrap.justify-space-between.headline.text-center(primary-title)
        span Request & Response Info
        v-btn(@click="dialog = false" icon)
          v-icon mdi-close
      v-card-text.fantasy__scrollbar.px-2.px-sm-6
        v-container(fluid)
          v-lazy( transition="fade-transition")
            v-row.pa-10(justify="center")
              v-col(cols="6" lg="6" md="6" sm="12")
                h4.white--text Request
                vue-json-pretty(:path="'res'" :data="request")
              v-col(cols="6" lg="6" md="6" sm="12")
                h4.white--text Response
                vue-json-pretty(:path="'res'" :data="response")


</template>

<script>
  import VueJsonPretty from 'vue-json-pretty'
  export default {
    name: "requestResponseDialog",
    components: {
      VueJsonPretty
    },
    props:{
      request:{
        type: Object,
        default: function(){
          return {}
        }
      },
      response:{
        type: Object,
        default: function(){
          return {}
        }
      }
    },
    data:() => ({
      dialog: false,
    }),
  }
</script>

<style lang="sass">
</style>